import { isLogicGroupValid } from '../../filterQueryFormat/logic/LogicGroup';
import { useContext, useState } from 'react';
import { useViewerActions } from '../../hooks/useViewerActions';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DeleteIcon, DuplicateIcon } from 'foundations-assets';
import UIIconButton from 'UIComponents/button/UIIconButton';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import ViewerGroupActionDeleteButtonPopover from './ViewerGroupActionDeleteButtonPopover';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewerConditionsGroupActions = props => {
  const {
    logicGroupIndex
  } = props;
  const {
    onCloneFilterGroup,
    onDeleteFilterGroup
  } = useViewerActions();
  const {
    internalDraftValue,
    isInEditMode,
    getIsUngated
  } = useContext(SegmentationFiltersInstanceContext);
  const [isGroupDeleteTriggered, setIsGroupDeleteTriggered] = useState(false);
  const onDelete = event => {
    event.stopPropagation();
    setIsGroupDeleteTriggered(true);
  };
  const onConfirm = () => {
    setIsGroupDeleteTriggered(false);
    onDeleteFilterGroup(logicGroupIndex);
  };
  if (!isInEditMode) {
    return null;
  }

  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  const logicGroup = internalDraftValue.conditions.get(String(logicGroupIndex));
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
  const isConditionValid = isLogicGroupValid(logicGroup, getIsUngated);
  const cloneGroupTooltipTitle = isConditionValid ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "newCustomerDataFilters.logicGroupActions.cloneGroup"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "newCustomerDataFilters.logicGroupActions.disabledCloneButton"
  });
  const deleteButton = /*#__PURE__*/_jsx(UIIconButton, {
    className: "m-left-1",
    "data-selenium-test": "fr-delete-group-btn",
    "data-test-id": "delete-group",
    onClick: onDelete,
    size: "small",
    use: "transparent",
    tooltipProps: {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "newCustomerDataFilters.logicGroupActions.deleteGroup"
      })
    },
    children: /*#__PURE__*/_jsx(DeleteIcon, {})
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIIconButton, {
      "data-selenium-test": "fr-clone-group-btn",
      "data-test-id": "clone-group",
      disabled: !isConditionValid,
      onClick: () => onCloneFilterGroup(logicGroupIndex),
      size: "small",
      use: "transparent",
      tooltipProps: {
        title: cloneGroupTooltipTitle
      },
      children: /*#__PURE__*/_jsx(DuplicateIcon, {})
    }), /*#__PURE__*/_jsx(ViewerGroupActionDeleteButtonPopover, {
      isOpen: isGroupDeleteTriggered,
      onCancel: () => setIsGroupDeleteTriggered(false),
      onConfirm: onConfirm,
      children: deleteButton
    })]
  });
};
export default ViewerConditionsGroupActions;